import React from "react";
import Button from "../../components/ui/Button";
import RemoteTable from "../../components/ui/RemoteTable";
import { printFullDate } from "../../utils/time";
import { useLanguage } from "../../context/LanguageContext";

const HmResults = () => {
    const { language } = useLanguage();

    const content = {
        columns: {
            sequence: { en: "Sequence", ar: "التسلسل" },
            homeworkName: { en: "Homework Name", ar: "اسم الواجب" },
            questionCount: { en: "Number of Questions", ar: "عدد الاسئلة" },
            result: { en: "Result", ar: "النتيجة" },
            grade: { en: "Grade", ar: "الدرجة" },
            solvedQuestions: { en: "Solved Questions", ar: "عدد الاسئلة المحلولة" },
            correctAnswers: { en: "Correct Answers", ar: "عدد الاسئلة الصحيحة" },
            answers: { en: "Answers", ar: "الاجابات" },
            answersUnavailable: { en: "-- Answers Unavailable --", ar: "--الاجابات غير متاحة--" },
            viewAnswers: { en: "View Answers", ar: "عرض الاجابات" },
            homeworkEndTime: { en: "Homework End Time", ar: "وقت انهاء الواجب" },
            homeworkStartTime: { en: "Homework Start Time", ar: "وقت بدأ الواجب" },
        },
    };

    let columns = [
        {
            name: content.columns.sequence[language],
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: content.columns.homeworkName[language],
            reorder: true,
            selector: (row) => (row.exam ? row.exam.name : ""),
            sortable: true,
            sortField: "exam_id",
        },
        {
            name: content.columns.questionCount[language],
            reorder: true,
            selector: (row) => row.questions_quantity,
            sortable: true,
            sortField: "questions_quantity",
        },
        {
            name: content.columns.result[language],
            reorder: true,
            selector: (row) => `${Math.round((row.result / row.full_result) * 100)} %`,
            sortable: true,
            sortField: "result",
        },
        {
            name: content.columns.grade[language],
            reorder: true,
            selector: (row) => `${row.result} / ${row.full_result}`,
            sortable: true,
            sortField: "result",
        },
        {
            name: content.columns.solvedQuestions[language],
            reorder: true,
            selector: (row) => row.is_selected_count,
            sortable: true,
            sortField: "is_selected_count",
        },
        {
            name: content.columns.correctAnswers[language],
            reorder: true,
            selector: (row) => row.is_correct_answers_count,
            sortable: true,
            sortField: "is_correct_answers_count",
        },
        {
            name: content.columns.answers[language],
            reorder: true,
            selector: (row) => (
                <>
                    {row.exam.show_results ? (
                        <Button
                            className="block px-1 py-1 text-center"
                            element="Link"
                            to={`../exam_results/${row.id}`}
                        >
                            {content.columns.viewAnswers[language]}
                        </Button>
                    ) : (
                        <span className="text-rose-500">
                            {content.columns.answersUnavailable[language]}
                        </span>
                    )}
                </>
            ),
        },
        {
            name: content.columns.homeworkEndTime[language],
            reorder: true,
            selector: (row) => printFullDate(row.updated_at, language),
            sortable: true,
            sortField: "updated_at",
        },
        {
            name: content.columns.homeworkStartTime[language],
            reorder: true,
            selector: (row) => printFullDate(row.created_at, language),
            sortable: true,
            sortField: "created_at",
        },
    ];

    return (
        <div>
            <div className="w-full">
                <RemoteTable
                    isAdmin={false}
                    api={`/api/user/exam_results/hm/paginate`}
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default HmResults;
